<template>
  <div v-if="showModal" class="login">

    <div class="form">
      <div class="form_item">

        <p class="title_login">{{inputForm.form_title||'签到'}}
          <!-- <span :style="'background-image:url(' + inputForm.button_image_path+');'" class="title_login_line"></span> -->
        </p>
        <div v-for="(item,index) in inputForm.options.data.menuArr" :key="index" class="login_L_item pointer">

          <component :options='item.options' :key="index" :is="item.type" :index="index">
          </component>

        </div>
        <div class="login_L_send">
          <div v-if="inputForm.button_image_path" @click="join"
            :style="'background-image:url(' + inputForm.button_image_path+');'" class="login_L_send_line">
            {{inputForm.button_text||'提交'}}</div>
          <a-button @click="join" class="qd" v-if="!inputForm.button_image_path" type="primary">
            {{inputForm.button_text||'提交'}}
          </a-button>
        </div>
      </div>

      <div @click="closeLogin" class="close">
        <img src="@/assets/关闭@2x.png" width="100%" alt="">
      </div>

    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { createForm } from "@/api/meetApi.js";
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    videoForm: {
      type: Object,
      default: () => ({}) // 默认返回一个空对象
    },
    inputForm: {
      type: Object,
      default: {
        options: {
          type: "formBox",
          form_type: "1",
          data: {
            menuArr: [{
              "type": "inputWork",
              "name": "Inpute",
              "label": "input框",
              "icon": "account-book",
              "options": {
                "col": 24,
                "typeof": 'input',
                "label": "姓名",
                "labelWidth": 80,
                "value": "",
                "type": "text",
                "clearable": false,
                "disabled": false,
                "prefixIcon": null,
                "suffixIcon": null,
                "placeholder": "请输入姓名",
                "requireMsg": "",
                "require": false,
                "reg": "",
                "regMsg": ""
              }
            }, {
              "type": "inputWork",
              "name": "Inpute",
              "label": "input框",
              "icon": "account-book",
              "options": {
                "col": 24,
                "typeof": 'input',
                "label": "医院",
                "labelWidth": 80,
                "value": "",
                "type": "text",
                "clearable": false,
                "disabled": false,
                "prefixIcon": null,
                "suffixIcon": null,
                "placeholder": "请输入医院",
                "requireMsg": "",
                "require": false,
                "reg": "",
                "regMsg": ""
              }
            }, {
              "type": "inputWork",
              "name": "Inpute",
              "label": "input框",
              "icon": "account-book",
              "options": {
                "col": 24,
                "typeof": 'input',
                "label": "科室",
                "labelWidth": 80,
                "value": "",
                "type": "text",
                "clearable": false,
                "disabled": false,
                "prefixIcon": null,
                "suffixIcon": null,
                "placeholder": "请输入科室",
                "requireMsg": "",
                "require": false,
                "reg": "",
                "regMsg": ""
              }
            }, {
              "type": "selectWork",
              "name": "Selecte",
              "label": "Select框",
              "icon": "deployment-unit",
              "options": {
                "col": 24,
                "typeof": 'select',
                "label": "职称",
                "labelWidth": 80,
                "value": undefined,
                "multiple": false,
                "clearable": false,
                "filterable": false,
                "disabled": false,
                "placeholder": "请选择职称",
                "optionsType": true,
                "optionsArray": ["主任医师", "副主任医师", "主治医师", "其他"],
                "optionsZd": "",
                "requireMsg": "",
                "require": false
              }
            }, {
              "type": "inputWork",
              "name": "Inpute",
              "label": "input框",
              "icon": "account-book",
              "options": {
                "col": 24,
                "typeof": 'input',
                "label": "联系方式",
                "labelWidth": 80,
                "value": "",
                "type": "text",
                "clearable": false,
                "disabled": false,
                "prefixIcon": null,
                "suffixIcon": null,
                "placeholder": "请输入联系方式",
                "requireMsg": "",
                "require": false,
                "reg": "",
                "regMsg": ""
              }
            }],
            pageCss: {
              page_css_margin: "0px 0px 0px 0px",
              page_css_padding: "24px 24px 24px 24px",
              page_css_interval: 16,
              page_css_radius: 0,
              page_css_bgc: "#ffffff",
              textBgc: "rgba(255,255,255,1)",
              myCss: '',
            }
          }
        }
      } // 默认返回一个空对象
    }
  },
  data() {
    return {
      showModal: false,
      form: {},
    }
  },
  created() {
    console.log(this.inputForm)
    const requireComponent = require.context(
      "@/components/video/formInput",
      false,
      /\.vue$/
    );
    requireComponent.keys().forEach(fileName => {
      let config = requireComponent(fileName);
      let fimeNameChange = fileName.replace(/^\.\//, "").replace(/\.\w+$/, "");
      let componentName =
        fimeNameChange.charAt(0).toLowerCase() + fimeNameChange.slice(1);
      Vue.component(componentName, config.default || config);
    });

  },
  methods: {
    show() {
      this.showModal = !this.showModal
    },
    closeLogin() {
      if (this.videoForm.is_must_sign_in == 1) {
        return this.$message.error('请先签到,签到完成即可正常观看！')
      } else {
        this.showModal = !this.showModal
      }
    },
    async join() {
      try {
        this.inputForm.options.data.menuArr.forEach(item => {
          if (item.options.require && !item.options.value) {
            let alertTxt = item.options.requireMsg ? item.options.requireMsg : '请填必填项！';
            throw new Error(alertTxt);
          }

          if (item.options.reg) {
            const regex = new RegExp(item.options.reg);
            console.log(item.options.reg,item.options.value, regex.test(item.options.value))
            if (!regex.test(item.options.value)) {
              let alertTxt = item.options.regMsg ? item.options.regMsg : item.options.label + '格式不正确！';
              throw new Error(alertTxt);
            }
          }
        })

        // 需要用到父数据。抛出给父组件
        return this.$emit('loginOK', this.inputForm);
        let sendData = JSON.parse(JSON.stringify(this.options));
        sendData.data.menuArr = this.formwork
        sendData.meeting_id = ''
        sendData.live_id = ''
        let data = await createForm(sendData)
        this.$message.success('签到成功！');
      } catch (e) {
        this.$message.error(e.message)
      }

    },
  },

}
</script>

<style lang="less" scoped>
.login_L_item {
  margin-bottom: 12px;
}

.login {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: #00000073;
  filter: alpha(opacity=50);
  display: flex;
  align-items: center;
  justify-content: center;
}

.form {
  width: 80%;
  max-width: 400px;
  max-height: 70%;
  margin: auto;
  background-color: #fff;
  padding: 24px 0;
  border-radius: 4px;
  position: relative;
  display: flex;
}

.form_item {
  flex: 1;
  overflow: auto;
  padding: 0 16px;
}
.qd {
  display: inline-block;
  height: 42px;
  // line-height: 42px;
  width: 100%;
  background-color: #4988fd;
  border-radius: 24px;
  text-align: center;
  color: white;
  margin-top: 5px;
}
.close {
  position: absolute;
  width: 40px;
  height: 40px;
  left: 50%;
  transform: translateX(-50%);
  bottom: -50px;
}
</style>
<style>
.login .ant-form-item-control-wrapper {
  padding-bottom: 8px;
}
.login .ant-form-horizontal {
  margin-bottom: 8px;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  width: 6px;
  background: rgba(#101f1c, 0.1);
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.5);
  background-clip: padding-box;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
  transition: background-color 0.3s;
  cursor: pointer;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, 0.3);
}
.title_login {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: 600;
  position: relative;
}
.title_login_line {
  position: absolute;
  width: 2em;
  bottom: 2px;
  left: 0;
  right: 0;
  margin: auto;
  height: 6px;
  background-position: 100% 100%;
  background-position: 100% 100%;
  background-repeat: no-repeat; /* 可选，根据需求 */
  -webkit-clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);
  clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);
}
</style>